import { State } from '@weave/schema-gen-ts/dist/schemas/platform-location-feature/v1/platform-enums/location_feature_enum.pb';
import { Feature } from '@weave/schema-gen-ts/dist/shared/feature/location_feature.pb';
import { i18next } from '@frontend/i18n';

export const SUBSCRIPTION_SETTINGS_URL = '/home/dashboard#settings/subscriptions';

export enum SelfUpgradeActionType {
  NONE = 'NONE',
  REQUEST_UPGRADE = 'REQUEST_UPGRADE',
  SCHEDULE_CALL = 'SCHEDULE_CALL',
  FREE_TRIAL = 'FREE_TRIAL',
  UPGRADE_NOW = 'UPGRADE_NOW',
}

export const SelfUpgradeFeatureNameMap: Partial<Record<Feature, string>> = {
  [Feature.FORMS]: i18next.t('Digital Forms', { ns: 'featurePromotion>>feature' }),
  [Feature.REVIEWS_HOME_ICON]: i18next.t('Reviews', { ns: 'featurePromotion>>feature' }),
  [Feature.CALL_INTELLIGENCE]: i18next.t('Call Intelligence', { ns: 'featurePromotion>>feature' }),
  [Feature.ONLINE_SCHEDULING]: i18next.t('Online Scheduling', { ns: 'featurePromotion>>feature' }),
  [Feature.PRACTICE_ANALYTICS]: i18next.t('Practice Analytics', { ns: 'featurePromotion>>feature' }),
  [Feature.WEAVE_VERIFY]: i18next.t('Weave Insurance Verification', { ns: 'featurePromotion>>feature' }),
  [Feature.ENHANCED_INSURANCE_VERIFICATION]: i18next.t('Weave Insurance Eligibility', {
    ns: 'featurePromotion>>feature',
  }),
};

export const FORMS_ACTIVE_STATES = [State.ACTIVE, State.FREEMIUM];
